import H4 from '@base/H4/H4';
import P2 from '@base/P2/P2';
import styled from '@emotion/styled';
import { Fonts, mediaQuery, Spacings } from '@styles/index';
import { commasIndianFormat, currencyCode } from '@utils/textHelper';

const Wrapper = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  ${mediaQuery.uptoMobile} {
    width: 50%;
  }
`;

const SlashPrice = styled(P2)`
  display: inline-block;
  font-weight: ${Fonts.SEMIBOLD};
  text-decoration-line: line-through;
  color: var(--color-text-secondary);
  margin-right: ${Spacings.SPACING_1B};
  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.H6};
  }
`;

const DiscountText = styled(SlashPrice)`
  display: inline-block;
  text-decoration-line: none;
`;

const StyPrice = styled(H4)`
  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.H4};
  }
`;

const BatchStorePrice = ({ activeStoreSku }) => {
  const { price, discountPercentage, maxRetailPrice, currency } =
    activeStoreSku;
  const slashText = discountPercentage
    ? `${currencyCode[currency]}${commasIndianFormat(maxRetailPrice)}`
    : '';

  const discountText = discountPercentage
    ? ` (${discountPercentage}%off)`
    : 'Price';

  const displayPrice = `${currencyCode[currency]}${commasIndianFormat(
    price
  )} only`;
  return (
    <Wrapper>
      <div>
        <SlashPrice>{slashText}</SlashPrice>
        <DiscountText>{discountText}</DiscountText>
      </div>
      <StyPrice>{displayPrice}</StyPrice>
    </Wrapper>
  );
};

export default BatchStorePrice;
